import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './pages.css';

const StartPage = () => {
  const navigate = useNavigate();
  const [isFirstImage, setIsFirstImage] = useState(true);
  const [fadeClass, setFadeClass] = useState('fade-in');

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass('fade-out');

      setTimeout(() => {
        setIsFirstImage(prev => !prev); 
        setFadeClass('fade-in'); 
      }, 500); 
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const handleStartClick = () => {
  const sound = new Audio('/sounds/game-start.mp3');
  sound.volume = 0.3;
  sound.play();

  navigate('/level1');
};

  return (
    <div className='page-wrapper'>
      
      <div className='centertext'><label className='pagetittle'>Find the cat Lumi!</label></div>
      <div className='centertext'><label className='pagetittle'>Can you beat all 3 rounds?</label></div>

      <img
        src={isFirstImage ? '/images/cats/meowgame.png' : '/images/cats/starmeows.png'}
        alt="Cat"
        className={`cat-page ${fadeClass}`}
      />

      <div className='centertext'>
        <button onClick={handleStartClick}>Start</button>
      </div>
    </div>
  );
};

export default StartPage;

